import { toast } from "react-toastify";
import { callApi } from "../../../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../../../ApiHelper/ApiUrl";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Spinner } from "reactstrap";
import EditIcon from "../../../../../components/Icons/EditIcon";
import { formatAmount } from "../../../../../utility/CommonFunctions";
import EditSalaryModal from "../EditSalaryModal";
import ViewDocumentModal from "../../../../Sites/ViewDocumentModal";
import BgBlurLoader from "../../../../../components/Loaders/BgBlurLoader";

export default function EmployeeSalaryDetail({ locationData, pageStatesMain }) {
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [salaryDetail, setSalaryDetali] = useState({
    isBaseData: [],
    earning: [],
    fromEmployer: [],
    deduction: [],
    basicSalary: 0,
    netSalary: 0,
    dailyWages: 0,
    sumOfFromEmployer: 0,
    siteSalaryHeadDetail: [],
    userId: locationData?.id,
  });

  const [pageStates, setPageStates] = useState({
    isSalaryCreated: false,
    isLoading: false,
    isLoadingSalaryCreation: false,
    isLoadingSalaryUpdation: false,
    isLoadingGetUserSalary: false,
    isLoadingOfferLetter: false,
  });

  const [showModal, setShowModal] = useState(false);
  const [salary, setSalary] = useState("50000");

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const handleUpdateSalary = (formData) => {
    if (locationData?.type === 1) {
      formData.userSalary = formData.userSalary?.map(item => ({
        amount: item.amount,
        officeSalaryHeadId: item.siteSalaryHeadId
      }));
    }
    const option = {
      method: "POST",
      data: formData,
    };
    const endPoint = apiUrl.update_user_salary + `?userId=${locationData?.id}`;
    setPageStates((prev) => ({
      ...prev,
      isLoadingSalaryUpdation: true,
    }));
    callApi(endPoint, option).then((res) => {
      setPageStates((prev) => ({
        ...prev,
        isLoadingSalaryUpdation: false,
      }));
      if (res?.status === true) {
        toast.success("Employee Salary Updated");
        GetEmployeeDetail();
        setShowModal(false);
      } else {
        toast.error(res?.message);
      }
    });
  };

  // console.log("salaryDetail-state==========>", salaryDetail);
  // console.log("isBaseData>>>>>>>>", salaryDetail?.isBaseData);
  // console.log("earning>>>>>>>>", salaryDetail?.earning);
  // console.log("deduction>>>>>>>>", salaryDetail?.deduction);
  // const [modalData, setModalData] = useState({});

  const {
    register: registerSalary,
    handleSubmit: handleSubmitSalary,
    reset: resetSalary,
    formState: { errors: errorsSalary },
  } = useForm();

  useEffect(() => {
    if (pageStatesMain?.activeTab === 9) {
      GetEmployeeDetail();
    }
  }, [pageStatesMain?.activeTab]);

  const GetEmployeeDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_profile + `?userId=${locationData?.id}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          isSalaryCreated: response?.data?.isSalaryCreated,
        }));
        const isOfficeStaff = response?.data?.type === 1;
        const siteId =
          response?.data?.type === 0
            ? response?.data?.usersites?.[0]?.site?.id
            : response?.data?.officeId;
        if (!response?.data?.isSalaryCreated) {
          GetSiteSalaryHeadDetail(siteId, isOfficeStaff);
        } else {
          GetUserSalary();
        }
      } else {
        toast.error(response?.message);
      }
    });
  };

  const GetSiteSalaryHeadDetail = (siteId, isOfficeStaff = false) => {
    let options = {
      method: "GET",
    };
    const Url = isOfficeStaff
      ? apiUrl.get_office_salary_head_detail + `?siteId=${siteId}&from=userSalary`
      : apiUrl.get_site_salary_head_detail + `?siteId=${siteId}&from=userSalary`;
    callApi(Url, options).then((res) => {
      if (res?.status === true) {
        setSalaryDetali((prev) => ({
          ...prev,
          siteSalaryHeadDetail: res?.data,
        }));
      }
    });
  };

  const GetUserSalary = () => {
    let options = {
      method: "GET",
    };
    const Url = apiUrl.get_user_salary + `?userId=${locationData?.id}`;
    setPageStates((prev) => ({
      ...prev,
      isLoadingGetUserSalary: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((prev) => ({
        ...prev,
        isLoadingGetUserSalary: false,
      }));

      if (res?.status === true) {
        const isBase = [];
        const earning = [];
        const fromEmployer = [];
        const deduction = [];
        let basicSalary = 0;
        let netSalary = 0;
        let dailyWages = 0;
        let sumOfFromEmployer = 0;

        for (const item of res.data) {
          const headRelation = item?.officesalaryhead || item?.sitesalaryhead;
          const head = headRelation?.salaryhead;
          if (!head) continue;

          if (head.fromEmployeer) {
            sumOfFromEmployer += Number(item?.amount ?? 0);
          }

          if (head.isBase && head.name !== "Other Allowances") {
            isBase.push(item);

            if (head.name === "Basic Salary")
              basicSalary = Number(item?.amount ?? 0);
            if (head.name === "Net Salary")
              netSalary = Number(item?.amount ?? 0);
            if (head.name === "Daily Wages")
              dailyWages = Number(item?.amount ?? 0);

            continue;
          }

          if (head.type === "earning") {
            if (head?.fromEmployeer) {
              fromEmployer.push(item);
            } else {
              earning.push(item);
            }
          } else {
            deduction.push(item);
          }
        }

        setSalaryDetali((prev) => ({
          ...prev,
          earning,
          fromEmployer,
          deduction,
          isBaseData: isBase,
          basicSalary,
          netSalary,
          dailyWages,
          sumOfFromEmployer,
        }));
      }
    });
  };

  const calculateTotal = () => {
    const earnings = salaryDetail?.earning || [];
    const fromEmployer = salaryDetail?.fromEmployer || [];
    const deductions = salaryDetail?.deduction || [];

    // Calculate Total (Earnings)
    const totalEarningsMonthly = earnings.reduce(
      (acc, curr) => acc + (Number(curr.amount) || 0),
      0,
    );

    // Calculate Total (fromEmployer)
    const totalFromEmployerMonthly = fromEmployer.reduce(
      (acc, curr) => acc + (Number(curr.amount) || 0),
      0,
    );

    // Calculate Total (Deductions)
    const totalDeductionsMonthly = deductions.reduce(
      (acc, curr) => acc + (Number(curr.amount) || 0),
      0,
    );

    return {
      totalEarningsMonthly,
      totalDeductionsMonthly,
      totalFromEmployerMonthly,
    };
  };

  const totals = calculateTotal();

  const onSubmitCreateSalary = (data) => {
    if (!locationData?.companyId) {
      toast.error(
        "Please assign company first in permission section before creating salary"
      );
      return;
    }
    if (locationData?.usercustomers?.length === 0) {
      toast.error(
        "Please assign customer first in permission section before creating salary"
      );
      return;
    }
    if (locationData?.type === 0 && locationData?.usersites?.length === 0) {
      toast.error(
        "Please assign site in permission section before creating salary"
      );
      return;
    }

    if (locationData?.type === 1) {
      data.userSalary = data.userSalary?.map(item => ({
        amount: item.amount,
        officeSalaryHeadId: item.siteSalaryHeadId
      }));
    }

    const option = {
      method: "POST",
      data: data,
    };
    const endPoint = apiUrl.create_user_salary + `?userId=${locationData?.id}`;
    setPageStates((prev) => ({
      ...prev,
      isLoadingSalaryCreation: true,
    }));
    callApi(endPoint, option).then((res) => {
      setPageStates((prev) => ({
        ...prev,
        isLoadingSalaryCreation: false,
      }));
      if (res?.status === true) {
        toast.success("Employee Salary Created");
        GetEmployeeDetail();
      } else {
        toast.error(res?.message);
      }
    });
  };

  const onSubmit = (data) => {
    let options = {
      method: "GET",
    };
    setPageStates((pre) => ({
      ...pre,
      isLoadingOfferLetter: true,
    }));
    let API = apiUrl.get_offer_letter + `?userId=${locationData?.id}`;
    callApi(API, options).then((response) => {
      setPageStates((pre) => ({
        ...pre,
        isLoadingOfferLetter: false,
      }));
      if (response?.status === true) {
        setSelectedDocument({ url: response?.data });
        setModal(true);
      } else {
        toast.error(response?.message);
      }
    });
  };

  // salary calculations
  const basicSalary = Number(salaryDetail?.basicSalary || 0);
  const sumOfFromEmployer = Number(salaryDetail?.sumOfFromEmployer || 0);
  const totalEarningsMonthly = Number(totals?.totalEarningsMonthly || 0);
  const totalFromEmployerMonthly = Number(
    totals?.totalFromEmployerMonthly || 0,
  );
  const totalDeductionsMonthly = Number(totals?.totalDeductionsMonthly || 0);
  const netSalary = Number(salaryDetail?.netSalary || 0);
  const grossAllowances =
    totalEarningsMonthly + totalFromEmployerMonthly - sumOfFromEmployer;
  const grossIncome = grossAllowances + basicSalary;
  const ctc = grossIncome + sumOfFromEmployer;

  // console.log(salaryDetail);

  return (
    <>
      {!pageStates?.isSalaryCreated && (
        <div className="d-flex justify-content-center align-items-start mt-5">
          <div
            className="card border-0 shadow-lg rounded-4"
            style={{ backgroundColor: "#f9fafd" }}
          >
            <div className="px-4 py-3 border-bottom d-flex align-items-center bg-white rounded-top-4">
              <i className="bi bi-wallet2 fs-4 me-2 text-primary"></i>
              <h4 className="mb-0 text-primary">Set Salary Details</h4>
            </div>
            <form onSubmit={handleSubmitSalary(onSubmitCreateSalary)}>
              <div className="px-4 py-4">
                <div className="row g-4">
                  {salaryDetail?.siteSalaryHeadDetail?.length > 0 &&
                    salaryDetail?.siteSalaryHeadDetail
                      ?.filter((i) => {
                        const name = i?.salaryhead?.name;
                        if (locationData?.type === 1) {
                          return name === "Basic Salary" || name === "Gross Salary" || (i?.salaryhead?.takeInput && name !== "Daily Wages");
                        } else {
                          return i?.salaryhead?.takeInput === true;
                        }
                      })
                      ?.map((item, index) => {
                        const fieldName = `userSalary[${index}].amount`;
                        const error = errorsSalary?.userSalary?.[index]?.amount;
                        const isEarning = item.salaryhead.type === "earning";

                        // console.log(item);

                        return (
                          <div className="col-md-6" key={item.salaryhead.id}>
                            <div className="d-flex align-items-start border rounded-3 bg-white shadow-sm p-3 position-relative">
                              <div className="w-100">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                  <strong className="text-dark">
                                    {item.salaryhead.name}
                                  </strong>
                                  <span
                                    className={`badge text-capitalize bg-${isEarning
                                      ? "success-subtle"
                                      : "danger-subtle"
                                      } text-${isEarning ? "success" : "danger"
                                      } fw-semibold`}
                                  >
                                    {item.salaryhead.type}
                                  </span>
                                </div>

                                <label
                                  htmlFor={fieldName}
                                  className="form-label fw-semibold small text-muted"
                                >
                                  Amount
                                </label>
                                <input
                                  type="text"
                                  onWheel={(e) => e.target.blur()}
                                  className={`form-control ${error ? "is-invalid" : ""
                                    }`}
                                  id={fieldName}
                                  {...registerSalary(
                                    `userSalary.${index}.amount`,
                                    {
                                      required: true,
                                      min: 0,
                                    },
                                  )}
                                  onChange={(e) => {
                                    e.target.value = e.target.value
                                      .replace(/[^0-9.]/g, "") // Allow only digits and dots
                                      .replace(/(\..*)\./g, "$1"); // Prevent multiple dots
                                  }}
                                  placeholder={`Enter amount`}
                                />
                                {error && (
                                  <div className="invalid-feedback">
                                    Please enter a valid amount for{" "}
                                    {item.salaryhead.name}.
                                  </div>
                                )}

                                <input
                                  type="hidden"
                                  {...registerSalary(
                                    `userSalary.${index}.siteSalaryHeadId`,
                                  )}
                                  value={item.id}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                </div>
              </div>
              <div className="text-center border-top p-3 bg-white rounded-bottom-4">
                <button
                  type="submit"
                  className="btn btn-primary px-5 py-2"
                  disabled={pageStates?.isLoadingSalaryCreation}
                >
                  {pageStates?.isLoadingSalaryCreation ? <Spinner /> : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {pageStates?.isSalaryCreated && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-12">
              <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3 d-flex align-items-center justify-content-between">
                <strong>Salary Structure</strong>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={() => setShowModal(true)}
                >
                  <EditIcon />
                  Edit Salary
                </button>
              </h4>
            </div>

            <EditSalaryModal
              show={showModal}
              onClose={() => setShowModal(false)}
              onUpdate={handleUpdateSalary}
              initialValue={salary}
              siteSalaryDetails={salaryDetail}
              isLoading={pageStates?.isLoadingSalaryUpdation}
            />

            <div className="col-12 mb-5">
              <div className="card shadow-sm rounded-4 px-4">
                <div className="row mb-4">
                  <div className="col-md-6">
                    <div className="border rounded-3 p-3 bg-light text-center">
                      <h4 className="text-muted mb-1">
                        {locationData?.type === 1 ? "Basic Salary" : "Daily Wages"}
                      </h4>
                      <h4 className="text-success fw-bold">
                        {formatAmount(
                          locationData?.type === 1
                            ? salaryDetail?.basicSalary
                            : salaryDetail?.dailyWages
                        )}
                      </h4>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3 mb-md-0">
                    <div className="border rounded-3 p-3 bg-light text-center">
                      <h4 className="text-muted mb-1">Gross Salary</h4>
                      <h4 className="text-primary fw-bold">
                        {formatAmount(grossIncome)}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 mb-5">
              <div className="card shadow-sm rounded-4">
                <div className="card-header bg-success text-white d-flex align-items-center justify-content-between">
                  <div className="h5 mb-0 text-white">
                    <i className="bi bi-currency-rupee me-2"></i> Allowances
                    Breakdown
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-bordered table-hover align-middle mb-0">
                    <thead className="table-light text-center">
                      <tr>
                        <th className="text-start">Allowances</th>
                        <th>Is Fixed</th>
                        <th>Is Condition Based</th>
                        <th>Rate</th>
                        <th>Based On</th>
                        <th className="text-end">Amount (₹)</th>
                      </tr>
                    </thead>

                    <tbody
                      className={`text-center ${pageStates?.isLoadingGetUserSalary
                        ? "loading-skeleton"
                        : ""
                        }`}
                    >
                      {salaryDetail?.earning?.length > 0 ? (
                        salaryDetail.earning.map((item, index) => {
                          const headRelation = item?.officesalaryhead || item?.sitesalaryhead;
                          return (
                            <tr key={index}>
                              <td className="text-start fw-semibold text-dark">
                                {headRelation?.salaryhead?.name || "--"}
                              </td>
                              <td>
                                <span
                                  className={`badge ${headRelation?.isFixed
                                    ? "bg-success"
                                    : "bg-secondary"
                                    }`}
                                >
                                  {headRelation?.isFixed ? "Yes" : "No"}
                                </span>
                              </td>
                              <td>
                                <span
                                  className={`badge ${headRelation?.isConditionBased
                                    ? "bg-info text-dark"
                                    : "bg-secondary"
                                    }`}
                                >
                                  {headRelation?.isConditionBased
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </td>
                              <td>
                                <span className="text-muted">
                                  {(headRelation?.rate &&
                                    `${headRelation?.rate}%`) ||
                                    "--"}
                                </span>
                              </td>
                              <td>
                                <span className="text-muted">
                                  {headRelation?.fixedBaseHead?.salaryhead
                                    ?.name || "--"}
                                </span>
                              </td>
                              <td className="fw-bold text-end">
                                {formatAmount(item?.amount)}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan={6}
                            className="text-center text-muted py-4"
                          >
                            No Earning Found
                          </td>
                        </tr>
                      )}
                    </tbody>

                    <tfoot className="table-light">
                      <tr>
                        <th className="text-start">Total</th>
                        <th colSpan={4}></th>
                        <th className="fw-bold text-end">
                          {formatAmount(totals?.totalEarningsMonthly)}
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-12 mb-5">
              <div className="card shadow-sm rounded-4">
                <div className="card-header bg-success text-white d-flex align-items-center justify-content-between">
                  <div className="h5 mb-0 text-white">
                    <i className="bi bi-currency-rupee me-2"></i> Employer
                    Contribution
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-bordered table-hover align-middle mb-0">
                    <thead className="table-light text-center">
                      <tr>
                        <th className="text-start">Allowances</th>
                        <th>Is Fixed</th>
                        <th>Is Condition Based</th>
                        <th>Rate</th>
                        <th>Based On</th>
                        <th className="text-end">Amount (₹)</th>
                      </tr>
                    </thead>

                    <tbody
                      className={`text-center ${pageStates?.isLoadingGetUserSalary
                        ? "loading-skeleton"
                        : ""
                        }`}
                    >
                      {salaryDetail?.fromEmployer?.length > 0 ? (
                        salaryDetail?.fromEmployer?.map((item, index) => {
                          const headRelation = item?.officesalaryhead || item?.sitesalaryhead;
                          return (
                            <tr key={index}>
                              <td className="text-start fw-semibold text-dark">
                                {headRelation?.salaryhead?.name || "--"}
                              </td>
                              <td>
                                <span
                                  className={`badge ${headRelation?.isFixed
                                    ? "bg-success"
                                    : "bg-secondary"
                                    }`}
                                >
                                  {headRelation?.isFixed ? "Yes" : "No"}
                                </span>
                              </td>
                              <td>
                                <span
                                  className={`badge ${headRelation?.isConditionBased
                                    ? "bg-info text-dark"
                                    : "bg-secondary"
                                    }`}
                                >
                                  {headRelation?.isConditionBased
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </td>
                              <td>
                                <span className="text-muted">
                                  {(headRelation?.rate &&
                                    `${headRelation?.rate}%`) ||
                                    "--"}
                                </span>
                              </td>
                              <td>
                                <span className="text-muted">
                                  {headRelation?.fixedBaseHead?.salaryhead
                                    ?.name || "--"}
                                </span>
                              </td>
                              <td className="fw-bold text-end">
                                {formatAmount(item?.amount)}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan={6}
                            className="text-center text-muted py-4"
                          >
                            No Earning Found
                          </td>
                        </tr>
                      )}
                    </tbody>

                    <tfoot className="table-light">
                      <tr>
                        <th className="text-start">Total</th>
                        <th colSpan={4}></th>
                        <th className="fw-bold text-end">
                          {formatAmount(totals?.totalFromEmployerMonthly)}
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-12 mb-5">
              <div className="card shadow-sm rounded-4">
                <div className="card-header bg-danger text-white d-flex align-items-center justify-content-between">
                  <div className="h5 mb-0 text-white">
                    <i className="bi bi-dash-circle-fill me-2"></i> Deductions
                    Breakdown
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-bordered table-hover align-middle mb-0">
                    <thead className="table-light text-center">
                      <tr>
                        <th className="text-start">Deductions</th>
                        <th>Is Fixed</th>
                        <th>Is Condition Based</th>
                        <th>Rate</th>
                        <th>Based On</th>
                        <th className="text-end">Amount (₹)</th>
                      </tr>
                    </thead>

                    <tbody className="text-center">
                      {salaryDetail?.deduction?.length > 0 ? (
                        salaryDetail.deduction.map((item, index) => {
                          const headRelation = item?.officesalaryhead || item?.sitesalaryhead;
                          return (
                            <tr key={index}>
                              <td className="text-start">
                                <p className="mb-0 fw-semibold text-dark">
                                  {headRelation?.salaryhead?.name || "--"}
                                </p>
                              </td>
                              <td>
                                <span
                                  className={`badge ${headRelation?.isFixed
                                    ? "bg-success"
                                    : "bg-secondary"
                                    }`}
                                >
                                  {headRelation?.isFixed ? "Yes" : "No"}
                                </span>
                              </td>
                              <td>
                                <span
                                  className={`badge ${headRelation?.isConditionBased
                                    ? "bg-info text-dark"
                                    : "bg-secondary"
                                    }`}
                                >
                                  {headRelation?.isConditionBased
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </td>
                              <td>
                                <span className="text-muted">
                                  {(headRelation?.rate &&
                                    `${headRelation?.rate}%`) ||
                                    "--"}
                                </span>
                              </td>
                              <td>
                                <span className="text-muted">
                                  {headRelation?.fixedBaseHead?.salaryhead
                                    ?.name || "--"}
                                </span>
                              </td>
                              <td className="fw-bold text-end">
                                {formatAmount(item?.amount)}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan={6}
                            className="text-center text-muted py-4"
                          >
                            No Deduction Found
                          </td>
                        </tr>
                      )}
                    </tbody>

                    <tfoot className="table-light">
                      <tr>
                        <th className="text-start">Total</th>
                        <th colSpan={4}></th>
                        <th className="fw-bold text-end">
                          {formatAmount(totals?.totalDeductionsMonthly)}
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="card shadow-sm rounded-4">
                <div className="card-header bg-primary text-white d-flex align-items-center justify-content-between">
                  <div className="h5 mb-0 text-white">
                    <i className="bi bi-cash-coin me-2"></i> Salary Breakdown
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-bordered table-hover align-middle mb-0">
                    <thead className="table-light text-center">
                      <tr>
                        <th className="text-start">Label</th>
                        <th>Description</th>
                        <th className="text-end">Monthly Amount (₹)</th>
                        <th className="text-end">Yearly Amount (₹)</th>
                      </tr>
                    </thead>

                    <tbody className="text-center">
                      <tr>
                        <td className="fw-semibold text-start">Gross Income</td>
                        <td className="text-muted">
                          Basic (
                          <span className="badge bg-info text-dark">
                            {formatAmount(basicSalary)}
                          </span>
                          ) + Allowances (
                          <span className="badge bg-warning text-dark">
                            {formatAmount(grossAllowances)}
                          </span>
                          )
                        </td>
                        <td className="fw-bold text-success text-end">
                          {formatAmount(grossIncome)}
                        </td>
                        <td className="fw-bold text-success text-end">
                          {formatAmount(grossIncome * 12)}
                        </td>
                      </tr>

                      <tr>
                        <td className="fw-semibold text-start">
                          Total Deductions
                        </td>
                        <td className="text-muted">From Deductions table</td>
                        <td className="fw-bold text-danger text-end">
                          {formatAmount(totalDeductionsMonthly)}
                        </td>
                        <td className="fw-bold text-danger text-end">
                          {formatAmount(totalDeductionsMonthly * 12)}
                        </td>
                      </tr>

                      <tr>
                        <td className="fw-semibold text-start">Net Pay</td>
                        <td className="text-muted">
                          Gross Income - Deductions
                        </td>
                        <td className="fw-bold text-primary text-end">
                          {formatAmount(netSalary)}
                        </td>
                        <td className="fw-bold text-primary text-end">
                          {formatAmount(netSalary * 12)}
                        </td>
                      </tr>

                      <tr className="table-primary">
                        <td className="fw-semibold text-start">CTC</td>
                        <td className="text-muted">
                          Gross Income + Employer Contribution
                        </td>
                        <td className="fw-bold text-end">
                          {formatAmount(ctc)}
                        </td>
                        <td className="fw-bold text-end">
                          {formatAmount(ctc * 12)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-cente justify-content-end gap-3 mt-4 mb-3">
            <div className="d-flex align-items-cente justify-content-end gap-3">
              <button type="submit" className="btn btn-primary px-5">
                Generate Appointment Letter
              </button>
            </div>
          </div>
        </form>
      )}
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
      {pageStates?.isLoadingOfferLetter && <BgBlurLoader />}
    </>
  );
}
